import { Crumbs } from "molecules/Breadcrumbs";
import React from "react";

const Assing_managment = () => {
  return (
    <div className="text-center">
      <h1>Assignment Managment Page</h1>
      <Crumbs />
    </div>
  );
};

export default Assing_managment;
